import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import {
    SvgIcon, IconButton, IconButtonProps, Typography, styled,
} from '@mui/material';
import { ComponentProps, useState } from 'react';

interface PropTypes extends Omit<IconButtonProps, 'onClick'> {
    edge?: 'start' | 'end';
    expanded: boolean;
    Icon?: typeof SvgIcon;
    iconProps?: ComponentProps<typeof SvgIcon>;
    onClick: (event: React.MouseEvent<HTMLButtonElement>, isExpanded: boolean) => void;
    showLessText?: string;
    showMoreText?: string;
}

const StyledIconButton = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
    }),
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
    display: 'none',
    paddingRight: theme.spacing(1),
}));

export const CollapsableToggle = (props: PropTypes): JSX.Element => {
    const {
        edge = 'start',
        expanded,
        Icon,
        iconProps = {},
        onClick,
        showLessText,
        showMoreText,
        ...rest
    } = props;
    const [expandedState, setExpandedState] = useState(expanded);

    const handleOnClick = (event: React.MouseEvent<HTMLButtonElement>): void => {
        event.preventDefault();

        if (onClick) {
            onClick(event, !expandedState);
        }
        setExpandedState(!expandedState);
    };

    const DefaultIcon = expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />;
    const ToggleIcon = Icon ? <Icon {...iconProps} /> : DefaultIcon;

    return (
        <StyledIconButton
            aria-expanded={expandedState}
            aria-label="show more"
            onClick={handleOnClick}
            {...rest}
        >
            {(edge === 'start') && ToggleIcon}
            {showMoreText && (
                <StyledTypography variant="caption">
                    {showMoreText}
                </StyledTypography>
            )}
            {showLessText && (
                <StyledTypography variant="caption">
                    {showLessText}
                </StyledTypography>
            )}
            {(edge === 'end') && ToggleIcon}

        </StyledIconButton>
    );
};
